import React from "react";

function Tab(props) {
  return (
    <div className="tab">
      {props.shared ? (
        <>
          <h3
            style={{
              color: props?.tab === "fol" ? "#131313" : "#B8B8B8",
              fontWeight: "400",
            }}
            onClick={() => props.setTab("fol")}
          >
            Folders/Projects
          </h3>
          <h6>|</h6>
        </>
      ) : null}
      <h3
        style={{
          color: props?.tab === "env" ? "#131313" : "#B8B8B8",
          fontWeight: "400",
        }}
        onClick={() => props.setTab("env")}
      >
        Envs/Subfolders
      </h3>
      <h6>|</h6>
      {props?.pwTabNR ? null : (
        <h3
          style={{
            color: props?.tab === "pass" ? "#131313" : "#B8B8B8",
            fontWeight: "400",
          }}
          onClick={() => props.setTab("pass")}
        >
          Passwords
        </h3>
      )}
    </div>
  );
}

export default Tab;
